import { arrow } from "@/designSystemIcons";
import { ReactNode } from "react";

import { Button } from "../Button/Button";

/**
 * The header row of a full-screen sheet on touch devices, as Compare Players
 * draws it: a minimize button that drops the sheet back down to the page, the
 * title, and the sheet's one action on the right.
 */
export const SheetHeader = ({
  title,
  onClose,
  closeLabel,
  action,
}: {
  title: string;
  onClose: () => void;
  /** Accessible name for the minimize button. */
  closeLabel: string;
  action?: ReactNode;
}) => (
  <div className="mx-auto flex w-full max-w-content items-center justify-between px-4 py-4 large:px-16 touch-device:px-4">
    <div className="flex items-center gap-x-3">
      <Button
        onClick={onClose}
        aria-label={closeLabel}
        variant="secondary"
        size="small"
        icon={<div className="size-3">{arrow}</div>}
      />
      <h2 className="text-base font-semibold">{title}</h2>
    </div>
    {action && <div className="flex items-center gap-x-2">{action}</div>}
  </div>
);
